import { Component, ViewChild, AfterViewInit, OnInit } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { AuthService } from 'src/app/services/auth/auth.service';
import { UserService } from 'src/app/services/user.service';

@Component({
    selector: 'app-transactions',
    templateUrl: './transactions.component.html',
    styleUrls: ['./transactions.component.scss'],
    standalone: false
})
export class TransactionsComponent implements OnInit, AfterViewInit {
  constructor(
    private authService: AuthService,
    private userService: UserService
  ) {

  }
  displayedColumns: string[] = ['card_brand','subscription_plan','subscription_status','amount','transaction_date'];

  dataSource = new MatTableDataSource<any>([]);
  loading = true;
  total_reports: number = 0;
  UUID: string = '';

  @ViewChild(MatPaginator) paginator!: MatPaginator;
  @ViewChild(MatSort) sort!: MatSort;

ngOnInit() {
  this.userService.getTransaction().subscribe({
    next: (transactions: any) => {
      const records = transactions.transactions || [];
      this.dataSource.data = records;
      this.dataSource.sort = this.sort;
      this.total_reports = records.length;
      this.dataSource.paginator = this.paginator;
      this.loading = false;
    },
    error: (error) => {
      console.error('Error fetching subscription info:', error);
      this.loading = false;
    }
  });
}

  ngAfterViewInit() {
      this.dataSource.paginator = this.paginator;
      this.dataSource.sort = this.sort;
  }
  getPlanName(planValue: number): string {
    switch (planValue) {
      case 0: return 'Hobbyist';
      case 1: return 'Professional';
      case 2: return 'Test Based Hobbyist';
      default: return 'Unknown';
    }
  }

  capitalize(text: string): string {
    return text ? text.charAt(0).toUpperCase() + text.slice(1).toLowerCase() : '';
  }

  getFormattedDate(dateString: string): string {
    const date = new Date(dateString);
    const day = date.getDate();
    const suffix = this.getDaySuffix(day);
    const month = date.toLocaleString('default', { month: 'long' });
    const year = date.getFullYear();
    return `${month} ${day}${suffix}, ${year}`;
  }

  getDaySuffix(day: number): string {
    if (day > 3 && day < 21) return 'th';
    switch (day % 10) {
      case 1: return 'st';
      case 2: return 'nd';
      case 3: return 'rd';
      default: return 'th';
    }
  }
}
